/* DriveAnything redesign — header menus, predictive search, gallery, inquiry pop-up. */
(function () {
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---- Mega menus ---- */
  const btns = $$('.ddbtn');
  const closeAll = () => btns.forEach((b) => { b.setAttribute('aria-expanded', 'false'); const p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.classList.remove('open'); });
  btns.forEach((b) => b.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = b.getAttribute('aria-expanded') === 'true';
    closeAll();
    if (!open) { b.setAttribute('aria-expanded', 'true'); document.getElementById(b.getAttribute('aria-controls')).classList.add('open'); }
  }));
  document.addEventListener('click', (e) => { if (!e.target.closest('.mega')) closeAll(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  $$('.mega').forEach((m) => {
    $$('.brands-l a[data-b]', m).forEach((a) => a.addEventListener('mouseenter', () => {
      $$('.brands-l a[data-b]', m).forEach((x) => x.classList.toggle('on', x === a));
      $$('.mpanel', m).forEach((p) => { p.hidden = p.dataset.b !== a.dataset.b; });
    }));
  });
  const mb = $('.menu-btn');
  if (mb) mb.addEventListener('click', () => { const n = $('#nav'); n.classList.toggle('open'); mb.setAttribute('aria-expanded', n.classList.contains('open')); });

  /* ---- Predictive search with inline completion (Shopify /search/suggest.json) ---- */
  function attachSuggest(input, opts) {
    if (!input || input.dataset.sug) return;
    opts = opts || {};
    input.dataset.sug = '1';
    input.setAttribute('autocomplete', 'off'); input.setAttribute('role', 'combobox'); input.setAttribute('aria-expanded', 'false'); input.setAttribute('aria-autocomplete', 'both');
    const box = input.parentElement; box.classList.add('sug-host');
    const ghost = document.createElement('div'); ghost.className = 'sug-ghost'; ghost.setAttribute('aria-hidden', 'true'); box.insertBefore(ghost, input);
    const list = document.createElement('ul'); list.className = 'sug-list'; list.setAttribute('role', 'listbox'); list.id = 'sug-' + Math.random().toString(36).slice(2, 8); box.appendChild(list);
    input.setAttribute('aria-controls', list.id);
    let items = [], cur = -1, seq = 0, t;
    const sync = () => { const r = input.getBoundingClientRect(), b = box.getBoundingClientRect(), cs = getComputedStyle(input); Object.assign(ghost.style, { left: (r.left - b.left) + 'px', top: (r.top - b.top) + 'px', width: r.width + 'px', height: r.height + 'px', font: cs.font, paddingLeft: cs.paddingLeft, lineHeight: r.height + 'px' }); };
    const bold = (l, q) => { const i = l.toLowerCase().indexOf(q.toLowerCase()); return i < 0 ? esc(l) : esc(l.slice(0, i)) + '<b>' + esc(l.slice(i, i + q.length)) + '</b>' + esc(l.slice(i + q.length)); };
    async function fetchSug(q) {
      const my = ++seq;
      const scope = opts.scope ? opts.scope() : '';
      const url = `${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}search/suggest.json?q=${encodeURIComponent((scope ? scope + ' ' : '') + q)}&resources[type]=query,product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor`;
      try {
        const r = await fetch(url); const j = await r.json(); if (my !== seq) return;
        const res = j.resources && j.resources.results || {};
        items = [
          ...(res.queries || []).map((x) => ({ kind: 'Search', label: x.text, href: x.url })),
          ...(res.collections || []).map((x) => ({ kind: 'Collection', label: x.title, href: x.url, img: x.featured_image && x.featured_image.url })),
          ...(res.products || []).map((x) => ({ kind: 'Product', label: x.title, sub: x.price ? x.price : '', href: x.url, img: x.image || (x.featured_image && x.featured_image.url) })),
        ].slice(0, 8);
      } catch (e) { items = []; }
      draw(q);
    }
    function draw(q) {
      cur = -1; sync();
      const top = items.find((s) => s.label.toLowerCase().startsWith(q.toLowerCase()));
      ghost.innerHTML = q && top && input.selectionStart === q.length ? `<span class="typed">${esc(q)}</span>${esc(top.label.slice(q.length))}` : '';
      ghost.dataset.full = q && top ? top.label : '';
      list.innerHTML = items.map((s, i) => `<li role="option" id="${list.id}-${i}" data-i="${i}">${s.img ? `<img src="${s.img}${s.img.includes('?') ? '&' : '?'}width=120" alt="">` : '<span class="noimg">⌕</span>'}<span><span class="l">${bold(s.label, q)}</span>${s.sub ? `<small>${esc(s.sub)}</small>` : ''}</span><em>${s.kind}</em></li>`).join('');
      list.classList.toggle('open', items.length > 0); input.setAttribute('aria-expanded', items.length > 0);
      $$('li', list).forEach((li) => { li.onmousedown = (e) => { e.preventDefault(); location.href = items[+li.dataset.i].href; }; });
    }
    input.addEventListener('input', () => { clearTimeout(t); const q = input.value.trim(); if (!q) { items = []; draw(''); return; } t = setTimeout(() => fetchSug(q), 140); });
    input.addEventListener('blur', () => setTimeout(() => { list.classList.remove('open'); ghost.innerHTML = ''; }, 150));
    input.addEventListener('keydown', (e) => {
      if ((e.key === 'Tab' || e.key === 'ArrowRight') && ghost.innerHTML && input.selectionStart === input.value.length) { e.preventDefault(); input.value = ghost.dataset.full; ghost.innerHTML = ''; fetchSug(input.value); }
      else if (e.key === 'ArrowDown' && items.length) { e.preventDefault(); cur = (cur + 1) % items.length; hl(); }
      else if (e.key === 'ArrowUp' && items.length) { e.preventDefault(); cur = (cur - 1 + items.length) % items.length; hl(); }
      else if (e.key === 'Enter' && cur >= 0) { e.preventDefault(); location.href = items[cur].href; }
      else if (e.key === 'Escape') { list.classList.remove('open'); ghost.innerHTML = ''; }
    });
    function hl() { $$('li', list).forEach((li, i) => li.classList.toggle('on', i === cur)); input.setAttribute('aria-activedescendant', cur >= 0 ? list.id + '-' + cur : ''); if (cur >= 0) { input.value = items[cur].label; ghost.innerHTML = ''; } }
    addEventListener('resize', sync);
  }
  window.DA = { attachSuggest };

  /* ---- Home: tool card toggle + video ---- */
  const tool = $('.da-home .tool');
  if (tool) {
    let mode = 'cars';
    const q = $('#da-q', tool);
    const set = (m) => {
      mode = m;
      $$('[data-mode]', tool).forEach((b) => b.setAttribute('aria-pressed', b.dataset.mode === m));
      $$('[data-pv]', tool).forEach((p) => { p.hidden = p.dataset.pv !== m; });
      $('#da-qlabel', tool).textContent = m === 'cars' ? 'What car are you looking for?' : 'What watch are you looking for?';
      q.placeholder = m === 'cars' ? 'Try 911, GT4 or M3' : 'Try Nautilus, Daytona or 5711';
      $('#da-go', tool).textContent = m === 'cars' ? 'Explore motorcars →' : 'Explore timepieces →';
      tool.action = m === 'cars' ? tool.dataset.cars : tool.dataset.watches;
    };
    $$('[data-mode]', tool).forEach((b) => b.addEventListener('click', () => { set(b.dataset.mode); q.focus(); }));
    tool.addEventListener('submit', (e) => { if (q.value.trim()) { e.preventDefault(); location.href = '/search?type=product&q=' + encodeURIComponent(q.value.trim()); } });
    attachSuggest(q, {});
    set('cars');
  }
  const vid = $('.da-home .hero video'), vb = $('.da-home .vbtn');
  // Play only a chosen segment of the hero film (e.g. Porsche + classics), looping inside it.
  if (vid && vid.dataset.loopTo) {
    const s = parseFloat(vid.dataset.start), a = parseFloat(vid.dataset.loopFrom), b = parseFloat(vid.dataset.loopTo);
    const seek = () => { if (!isNaN(s) && vid.currentTime < s - 0.5 || vid.currentTime > b) vid.currentTime = s; };
    vid.addEventListener('loadedmetadata', seek, { once: true });
    if (vid.readyState >= 1) seek();
    vid.addEventListener('timeupdate', () => { if (vid.currentTime >= b) vid.currentTime = isNaN(a) ? s : a; });
  }
  if (vid && vb) {
    const P = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>', PL = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5l12 7-12 7z"/></svg>';
    const s = () => { vb.innerHTML = vid.paused ? PL : P; vb.setAttribute('aria-label', vid.paused ? 'Play video' : 'Pause video'); };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { vid.removeAttribute('autoplay'); vid.pause(); }
    vb.onclick = () => { vid.paused ? vid.play() : vid.pause(); s(); }; vid.onplay = vid.onpause = s; s();
  }

  /* ---- Collection: search box + sort ---- */
  $$('.da-coll .searchbox input').forEach((i) => attachSuggest(i, {}));
  const sort = $('.da-coll #sort');
  if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
  const ft = $('.da-coll #ft');
  if (ft) ft.addEventListener('click', () => { const f = $('#filters'); f.classList.toggle('open'); ft.setAttribute('aria-expanded', f.classList.contains('open')); });

  /* ---- Product: gallery + inquiry pop-up ---- */
  const main = $('.da-prod #main');
  if (main) {
    const thumbs = $$('.da-prod #thumbs button'), count = $('#gcount');
    const lb = $('#lb'), lbimg = $('#lbimg'), lbcount = $('#lbcount');
    let cur = 0;
    const show = (i) => {
      if (!thumbs.length) return;
      cur = (i + thumbs.length) % thumbs.length;
      const b = thumbs[cur];
      main.src = b.dataset.full;
      thumbs.forEach((x) => x.setAttribute('aria-pressed', x === b));
      b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      if (count) count.textContent = (cur + 1) + ' / ' + thumbs.length;
      if (lb?.open) { lbimg.src = b.dataset.zoom || b.dataset.full; lbcount.textContent = count.textContent; }
      const nx = thumbs[(cur + 1) % thumbs.length]; if (nx) (new Image()).src = nx.dataset.full;
    };
    thumbs.forEach((b, i) => b.addEventListener('click', () => show(i)));
    $('#gprev')?.addEventListener('click', () => show(cur - 1));
    $('#gnext')?.addEventListener('click', () => show(cur + 1));
    document.addEventListener('keydown', (e) => {
      if (e.target.closest('input,textarea,select') || $('#inq')?.open) return;
      if (e.key === 'ArrowRight') show(cur + 1); else if (e.key === 'ArrowLeft') show(cur - 1);
    });
    const openLb = () => { if (!lb || !thumbs.length) return; lb.showModal(); show(cur); };
    main.style.cursor = 'zoom-in';
    main.addEventListener('click', openLb);
    $('#gzoom')?.addEventListener('click', openLb);
    $('#lbx')?.addEventListener('click', () => lb.close());
    $('#lbprev')?.addEventListener('click', () => show(cur - 1));
    $('#lbnext')?.addEventListener('click', () => show(cur + 1));
    lb?.addEventListener('click', (e) => { if (e.target === lb) lb.close(); });
    let lx = null;
    lb?.addEventListener('touchstart', (e) => { lx = e.touches[0].clientX; }, { passive: true });
    lb?.addEventListener('touchend', (e) => { if (lx === null) return; const dx = e.changedTouches[0].clientX - lx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); lx = null; });
    const box = $('#mainbox'); let x0 = null;
    box?.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    box?.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null; });
  }
  const dlg = $('.da-prod #inq');
  if (dlg) {
    const msgs = JSON.parse(dlg.dataset.msgs || '{}');
    const open = (kind) => {
      $('#inqTitle', dlg).textContent = { inquire: 'Inquire about this car', viewing: 'Schedule a viewing', price: 'Request price', buy: 'Buy this watch', question: 'Ask a question' }[kind] || 'Inquire';
      $('#inqMsg', dlg).value = msgs[kind] || msgs.question || '';
      $$('#inqOpts input', dlg).forEach((c) => { c.checked = (kind === 'viewing' && c.value === 'Schedule a viewing') || (kind === 'price' && c.value === "Today's price"); });
      dlg.showModal(); $('input[name="contact[name]"]', dlg).focus();
    };
    $$('[data-inq]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); open(b.dataset.inq); }));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    $('.x', dlg).addEventListener('click', () => dlg.close());
    // fold checkbox choices into the message so Shopify's contact email carries them
    $('form', dlg).addEventListener('submit', () => {
      const picks = $$('#inqOpts input:checked', dlg).map((c) => c.value);
      const via = ($('input[name="via"]:checked', dlg) || {}).value;
      const extra = $('#inqExtra', dlg);
      extra.value = [picks.length ? 'Wants: ' + picks.join(', ') : '', via ? 'Best way to reach: ' + via : ''].filter(Boolean).join(' · ');
    });
    const posted = /contact_posted=true/.test(location.search) || !!$('#inq-posted .notice');
    if (posted) {
      if (location.hash) history.replaceState(null, '', location.pathname + location.search);
      const n = $('#inq-posted .notice');
      if (n) { n.classList.add('sent'); n.scrollIntoView({ block: 'center' }); }
      const t = document.createElement('div');
      t.className = 'da-toast'; t.setAttribute('role', 'status');
      t.innerHTML = '<b>✓ Inquiry sent</b><span>Brett will be in touch shortly.</span>';
      document.body.appendChild(t);
      setTimeout(() => t.classList.add('out'), 7000);
    } else if (location.hash === '#inquire') open(dlg.dataset.default || 'question');
  }
  const rm = $('.da-prod #rm'), ab = $('.da-prod #about');
  if (rm && ab) rm.addEventListener('click', () => { ab.classList.toggle('open'); rm.firstChild.textContent = ab.classList.contains('open') ? 'Read less ' : 'Read more '; });
})();
